<si-trendviewer
  class="card elevation-1 overflow-hidden mt-4 mb-5"
  [editable]="true"
  [instanceId]="instanceId"
></si-trendviewer>
